import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Landing from './pages/Landing';
import StudentChat from './pages/StudentChat';
import StudentDashboard from './pages/StudentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import SharedChat from './pages/SharedChat';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import LessonView from './pages/LessonView';
import ManageLMS from './pages/ManageLMS';
import AssessmentView from './pages/AssessmentView';
import Submissions from './pages/Submissions';
import LiveSessions from './pages/LiveSessions';
import MyProfile from './pages/MyProfile';
import MockTests from './pages/MockTests';
import Notebooks from './pages/Notebooks';

// Layout
import Layout from './components/common/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {
  const { isAuthenticated, user } = useAuthStore();

  // Redirect based on role
  const getDefaultRoute = () => {
    if (!isAuthenticated) return '/';
    switch (user?.role) {
      case 'admin': return '/admin';
      default: return '/chat';
    }
  };

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={
        isAuthenticated ? <Navigate to={getDefaultRoute()} /> : <Landing />
      } />
      <Route path="/login" element={
        isAuthenticated ? <Navigate to={getDefaultRoute()} /> : <Login />
      } />
      <Route path="/register" element={
        isAuthenticated ? <Navigate to={getDefaultRoute()} /> : <Register />
      } />

      {/* Public shared conversation view */}
      <Route path="/shared/:token" element={<SharedChat />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        {/* Student routes */}
        <Route path="/chat" element={<StudentChat />} />
        <Route path="/dashboard" element={<StudentDashboard />} />
        <Route path="/profile" element={<MyProfile />} />

        {/* LMS routes (all authenticated users) */}
        <Route path="/lms/courses" element={<Courses />} />
        <Route path="/lms/courses/:id" element={<CourseDetail />} />
        <Route path="/lms/lessons/:id" element={<LessonView />} />
        <Route path="/lms/mock-tests" element={<MockTests />} />
        <Route path="/notebooks" element={<Notebooks />} />
        <Route path="/lms/assessments/:id" element={<AssessmentView />} />
        <Route path="/lms/submissions" element={<Submissions />} />
        <Route path="/lms/live-sessions" element={<LiveSessions />} />

        {/* Manage LMS (admin only) */}
        <Route path="/lms/manage" element={
          <ProtectedRoute roles={['admin']}>
            <ManageLMS />
          </ProtectedRoute>
        } />

        {/* Admin routes */}
        <Route path="/admin" element={
          <ProtectedRoute roles={['admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
      </Route>

      {/* Fallback - redirect to appropriate page */}
      <Route path="*" element={<Navigate to={getDefaultRoute()} />} />
    </Routes>
  );
}

export default App;
